import React from 'react';
import { useTranslation } from 'react-i18next';
import { FilterMinimalStyleCircle88 } from 'shared/assets/icons';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './no-filter-results-state.style';

export type NoFilterResultsStateProps = {
  onReset?: () => void;
};

export const NoFilterResultsState: React.FC<NoFilterResultsStateProps> = ({
  onReset,
}) => {
  const { t } = useTranslation();
  const handleReset = () => onReset?.();

  return (
    <Styled.Container>
      <Styled.IconContainer>
        <Icon icon={FilterMinimalStyleCircle88} />
      </Styled.IconContainer>
      <Styled.Title>{t('goals.filter-empty.title')}</Styled.Title>
      {!!onReset && (
        <Button
          onClick={handleReset}
          variant={Variants.Text}
          size={Sizes.Medium}
          color={Colors.Primary}
        >
          {t('goals.filter-empty.action')}
        </Button>
      )}
    </Styled.Container>
  );
};
